import { useRef } from 'react';
import type { GlobalFormRef } from '../components/GlobalForm/GlobalForm';

/**
 * 全局表单Hook
 * 提供表单实例引用和便捷方法
 */
export const useGlobalForm = () => {
  const formRef = useRef<GlobalFormRef>(null);

  return {
    formRef,
    submit: () => formRef.current?.submit(),
    reset: () => formRef.current?.reset(),
    getValues: () => formRef.current?.getValues(),
    setFieldsValue: (values: any) => formRef.current?.setFieldsValue(values),
    getForm: () => formRef.current?.form,
  };
};

